<app-base-modal
  title="You're up to date!"
  size="wide"
  titleColor="var(--color-evergreen)"
  closeIconColor="var(--color-evergreen)"
  [gradientBackground]="'linear-gradient(to bottom, var(--color-sundown), var(--color-parchment))'"
  (closed)="close()"
>
  <p class="update-complete-version">
    flip* has been updated to <strong>v {{ data.version }}</strong>
  </p>

  <ng-container *ngIf="data.newFeatures?.length || data.bugFixes?.length">
    <hr class="update-complete-divider" />

    <div class="update-complete-section" *ngIf="data.newFeatures?.length">
      <p class="update-complete-section-heading">New Features</p>
      <ul>
        <li *ngFor="let feature of data.newFeatures">{{ feature }}</li>
      </ul>
    </div>

    <div class="update-complete-section" *ngIf="data.bugFixes?.length">
      <p class="update-complete-section-heading">Bug Fixes</p>
      <ul>
        <li *ngFor="let fix of data.bugFixes">{{ fix }}</li>
      </ul>
    </div>
  </ng-container>

  <div actions>
    <button type="button" class="update-complete-close-pill" (click)="close()">
      Close
    </button>
  </div>
</app-base-modal>
